import React from "react";

export default function Footer() {
  return (
    <footer>
      <p>
        Made with ❤ by{" "}
        <a target="_blanck" href="https://github.com/KrishnaKumarKeshri96">
          Krishna Keshri
        </a>
      </p>
    </footer>
  );
}
